import AddCommentOnCodeButton from "./AddCommentOnCodeButton";
import AddCommentOnModelDescriptionButton from "./AddCommentOnModelDescriptionButton";

const AddCommentButton = () => {
  return (
    <>
      <AddCommentOnModelDescriptionButton />
      <AddCommentOnCodeButton />
    </>
  );
};

export default AddCommentButton;
